import PropTypes from 'prop-types';
import React from 'react';
import { Input, Prefix, Radio, Suffix } from 'web-ui-components/lib/atoms/forms';
import { FieldBody } from 'web-ui-components/lib/molecules/forms';
import { getCurrencyPrefix } from '../../../../helpers/fieldHelpers';

const CurrencyAmountField = ({
	id,
	currencyCode,
	amount = '',
	handleOnChange,
	isDisabled = false,
	isRadioChecked,
	onRadioChange,
	showRadio = false,
	handleOnBlur,
	isDifferentCurrency,
}) => {
	const hasSuffix = !!currencyCode;
	const currencySign = getCurrencyPrefix(currencyCode);
	const hasPrefix = !!currencySign;

	const getBiocatchIdentifier = isDifferentCurrency ? 'from-currency-amount' : 'send-currency-amount';

	return (
		<FieldBody>
			{showRadio && <Radio id={id} onChange={onRadioChange} checked={isRadioChecked} label="" />}
			{hasPrefix && <Prefix isDisabled={isDisabled}>{currencySign}</Prefix>}
			<Input
				disabled={isDisabled}
				id={`input-${id}`}
				data-bb={getBiocatchIdentifier}
				type="text"
				value={amount}
				hasPrefix={hasPrefix}
				hasSuffix={hasSuffix}
				onChange={handleOnChange}
				onBlur={handleOnBlur}
			/>
			{hasSuffix && <Suffix isDisabled={isDisabled}>{currencyCode}</Suffix>}
		</FieldBody>
	);
};
CurrencyAmountField.defaultProps = {
	handleOnBlur: () => {},
};
CurrencyAmountField.propTypes = {
	id: PropTypes.string.isRequired,
	amount: PropTypes.string,
	currencyCode: PropTypes.string,
	handleOnChange: PropTypes.func.isRequired,
	isRadioChecked: PropTypes.bool,
	isDisabled: PropTypes.bool.isRequired,
	showRadio: PropTypes.bool,
	onRadioChange: PropTypes.func,
	handleOnBlur: PropTypes.func,
};

export default CurrencyAmountField;
